export enum RetailBonusStatus {
    PENDING = 167,
    ORDERTOTAL_CALCULATION_INPROGRESS = 168,
    ORDERTOTAL_CALCULATION_SUCCESS = 169,
    REVISE_INPROGRESS = 170,
    PRODUCT_FILE_UPLOAD_INPROGRESS = 171,
    PRODUCT_FILE_UPLOAD_SUCCESS = 172,
    PRODUCT_FILE_UPLOAD_FAILED = 173,
    ORDER_GENERATION_INPROGRESS = 174,
    ORDER_GENERATION_SUCCESS = 175,
    ORDER_GENERATION_FAILED = 176,
    QUALIFIED_SUBSCRIBER_NOT_AVAILABLE = 212,
    SUBSCRIBER_NOT_AVAILABLE = 213
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/retail-bonus-status.enum.ts